module.exports = __webpack_public_path__ + "img/premium_sports.ccf9b24.svg";